"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOW_EXIST = exports.QUANMIN_APPNAME = void 0;

/**
 * @file 全民小视频 常量
 * @author zhangyanting <zhangyanting@baidu.com>
 */
var QUANMIN_APPNAME = 'bdminivideo';
exports.QUANMIN_APPNAME = QUANMIN_APPNAME;
var LOW_EXIST = {
  status: 101,
  message: '该版本不支持此端能力'
};
exports.LOW_EXIST = LOW_EXIST;